// extracted by mini-css-extract-plugin
export var link = "index-module--link--31m6j";
export var root = "index-module--root--KoDdv";